import { render, staticRenderFns } from "./vPostulante.vue?vue&type=template&id=305c7be0&scoped=true&"
import script from "./vPostulante.vue?vue&type=script&lang=js&"
export * from "./vPostulante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c7be0",
  null
  
)

export default component.exports